

export const WAITING_FOR_BOTH_PAYMENTS = 'waiting_for_both_payments'

export const PAYMENT_REMINDER_SENT = 'payment_reminder_sent'



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/treatment/state-name.js